import React, { useState } from 'react';

import './desktop-voucher-product-list-style.scss';

import Typography from '@src/componentsNew/Typography/Typography';
import DesktopProductListFilter from '@src/componentsNew/Filter/DesktopProductListFilter/DesktopProductListFilter';
import DesktopProductListSortingFilter from '@src/componentsNew/Filter/DesktopProductListFilter/DesktopProductListSortingFilter';
import DesktopBasicProductList from '@src/componentsNew/ProductList/Basic/DesktopBasicProductList';

import { productsVariables } from '@components/ProductPage/ProductList/__generated__/products';

export interface IProps {
  initialVariables: productsVariables;
  variables: productsVariables;
  setVariables: (value: productsVariables) => void;
}

const DesktopVoucherProductListPage = ({ initialVariables, variables, setVariables }: IProps) => {
  const [numOfProducts, setNumOfProducts] = useState<number>(0);

  return (
    <div id="desktop-voucher-product-list-wrapper">
      <div className="search-result-top-wrapper">
        <div className="content-area">
          <div className="content-top">
            <Typography variant="h6" component="h4">
              Applicable Products
            </Typography>

            {numOfProducts > 0 ? (
              <div className="sorting-filter-area">
                <Typography
                  variant="body1"
                  component="span"
                  style={{ color: '#666666' }}
                >{`${numOfProducts} Items`}</Typography>

                <DesktopProductListSortingFilter variables={variables} setVariables={setVariables} />
              </div>
            ) : null}
          </div>
        </div>

        <div className="divider" />
      </div>

      <div className="main-area">
        <div className="desktop-search-result-filter-wrapper">
          <DesktopProductListFilter
            initialVariables={initialVariables}
            variables={variables}
            setVariables={setVariables}
          />
        </div>

        <div className={`products-area ${numOfProducts === 0 ? 'no-product' : ''}`}>
          <DesktopBasicProductList
            initialVariables={initialVariables}
            variables={variables}
            setNumOfProducts={setNumOfProducts}
          />
        </div>
      </div>
    </div>
  );
};

export default DesktopVoucherProductListPage;
